import React from "react";
import Icon from "../icons/Icons";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  otherTabsColor?: boolean;
  className?: string;
}

export function Pagination({
  currentPage,
  totalPages,
  onPageChange,
  otherTabsColor = true,
  className,
}: PaginationProps) {
  if (totalPages <= 1) return null;

  const getPageNumbers = () => {
    const pages: (number | "...")[] = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 2) {
        pages.push(1, 2, 3, "...", totalPages);
      } else if (currentPage >= totalPages - 1) {
        pages.push(1, "...", totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(currentPage - 1, currentPage, currentPage + 1);
        if (currentPage + 1 < totalPages - 1) {
          pages.push("...");
        }
        pages.push(totalPages);
      }
    }
    return pages;
  };

  const isFirst = currentPage === 1;
  const isLast = currentPage === totalPages;

  return (
    <div
      className={`w-fit flex items-center justify-center gap-3.5 ${className}`}
    >
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={isFirst}
        className={`rounded-xs border w-7 h-7 flex items-center justify-center transition ${isFirst ? "opacity-50 cursor-not-allowed border-[#cfcfcf]" : "hover:shadow-[0px_5px_10px_0px_#0000001A] border-[rgb(var(--primary-alpha)/0.4)] hover:border-[rgb(var(--primary-alpha)/0.8)]"}`}
        aria-label="Previous Page"
      >
        <Icon.dropdownDownArrow className="rotate-90" />
      </button>

      <div className="flex items-center gap-2">
        {getPageNumbers().map((page, index) => (
          <React.Fragment key={index}>
            {page === "..." ? (
              <span className="px-2 text-2xl font-semibold text-primaryBlack">
                ...
              </span>
            ) : (
              <button
                onClick={() => onPageChange(page)}
                className={`w-9 h-8 text-2xs sm:text-2sm rounded-md flex items-center justify-center transition ${currentPage === page ? "font-semibold bg-[rgb(var(--primary-alpha)/0.9)] text-white" : `font-medium text-[rgb(var(--primary-alpha))] ${otherTabsColor ? "bg-[rgb(var(--primary-alpha)/0.1)] hover:bg-[rgb(var(--primary-alpha)/0.2)]" : "bg-white"}`}
`}
              >
                {page}
              </button>
            )}
          </React.Fragment>
        ))}
      </div>

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={isLast}
        className={`rounded-xs border w-7 h-7 flex items-center justify-center transition ${isLast ? "opacity-50 cursor-not-allowed border-[#cfcfcf]" : "hover:shadow-[0px_5px_10px_0px_#0000001A] border-[rgb(var(--primary-alpha)/0.4)] hover:border-[rgb(var(--primary-alpha)/0.8)]"}`}
        aria-label="Next Page"
      >
        <Icon.dropdownDownArrow className="-rotate-90" />
      </button>
    </div>
  );
}
